import { render, staticRenderFns } from "./OverDueReport.vue?vue&type=template&id=5785ac56"
import script from "./OverDueReport.vue?vue&type=script&lang=js"
export * from "./OverDueReport.vue?vue&type=script&lang=js"
import style0 from "./OverDueReport.vue?vue&type=style&index=0&id=5785ac56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports